import strings from "@gromia/strings/valuationStepper";
import { renderString } from "@gromia/utils/useString";
import * as E from "fp-ts/lib/Either";
import * as io from "io-ts";

function onError() {}

function __render(rawStringValue: string, v?: string | number) {
  const options = v !== undefined ? { variables: { v }, onError } : { onError };
  return renderString(rawStringValue, options);
}

function r(label: string, value: string, v: string | number) {
  return `${__render(label)}: ${__render(value, v)}`;
}

// feature
function f(label: string, dict: Record<string, boolean>, v: string) {
  const boolean = `{v,select,true{Sì} false{No} other{{v}}}`;
  return `${__render(label, v)}: ${
    __render(
      boolean,
      ((dict ?? {})[v] ?? false).toString(),
    )
  }`;
}

/*
 "externalSpaces": {
   "balcony": true,
   "garage": true,
   "terrace": false,
   "parking": true,
   "garden": true
 },
 "internalSpaces": {
   "elevator": true,
   "attic": true,
   "kitchen": true,
   "garret": true,
   "fireplace": true
 }
*/

type OpaqueData = Record<string, unknown>;

const DataDecoder = io.type({
  type: io.string,
  condition: io.string,
  rooms: io.string,
  bathrooms: io.string,
  floor: io.string,
  floors: io.string,
  constructionYear: io.number,
  area: io.number,
  areaGarden: io.union([io.number, io.null, io.undefined]),
  timeframe: io.string,
  internalSpaces: io.record(io.string, io.boolean),
  externalSpaces: io.record(io.string, io.boolean),
});

export function humanReadableValuationData(opaque: OpaqueData) {
  const validation = DataDecoder.decode(opaque);

  if (E.isLeft(validation)) {
    console.error(
      "error parsing opaque for humanReadableValuationData",
      validation.left,
    );
    return undefined;
  }

  const data = validation.right;

  const identity = `{v}`;

  const sep = "\n";

  const fields = [
    r(strings.type1Title, strings.type1Label, data.type),
    r(strings.condition, strings.conditionLabel, data.condition),

    r(strings.roomsTitle, strings.rooms, data.rooms),
    r(strings.bathroomsTitle, strings.bathrooms, data.bathrooms),

    r(strings.floorTitle, strings.floor, data.floor),
    r(strings.floorsTitle, strings.floors, data.floors),

    r(strings.constructionYearTitle, identity, data.constructionYear),
    r(strings.areaTitle, identity, data.area),
    r(strings.areaGarden, identity, data.areaGarden ?? 0),

    f(strings.internalSpaces, data.internalSpaces, "elevator"),
    f(strings.internalSpaces, data.internalSpaces, "attic"),
    f(strings.internalSpaces, data.internalSpaces, "kitchen"),
    f(strings.internalSpaces, data.internalSpaces, "fireplace"),
    f(strings.internalSpaces, data.internalSpaces, "garret"),

    f(strings.externalSpaces, data.externalSpaces, "balcony"),
    f(strings.externalSpaces, data.externalSpaces, "garage"),
    f(strings.externalSpaces, data.externalSpaces, "garden"),
    f(strings.externalSpaces, data.externalSpaces, "parking"),
    f(strings.externalSpaces, data.externalSpaces, "terrace"),

    r(strings.timeframeTitle, strings.timeframe, data.timeframe),
  ];

  return fields.join(sep);
}
